module.exports = __webpack_public_path__ + "img/OneMountain.9b240943.png";